// /**
//  * Partner - Detail
//  */

// React
import React, { useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import {
  getUsersByPartnerIdAction,
  getUsersBeAdminPartnerAction,
  updatePartnerAdminActions,
} from '../actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectUsersListByPartnerId,
  makeSelectUsersListBeAdminPartner,
  makeSelectError,
  makeSelectLoading,
  makeSelectCountList,
} from '../selectors';

// UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Paper,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  IconButton,
  FormLabel,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPlus,
  mdiArrowRight,
  mdiTools,
  mdiPhoneOutline,
  mdiMapMarkerOutline,
  mdiAccountTie,
  mdiAccountTieVoice,
  mdiArrangeBringToFront,
  mdiAccountCash,
  mdiClose,
  mdiCloseThick,
  mdiCheck,
  mdiMinus,
  mdiPaperclip,
} from '@mdi/js';

// Helper
import { formaterPhoneNumber } from '../../../utils/helpers';

// Components
import ListUser from './list-users';
import AddUser from './add-user';

// Type
import { SelectorPropsDetail, PropsDetail, PayloadUpdate } from '../interfaces';
import tokensRepository from 'client-sdk/src/Repository/token-repository';
import theme from '../../../theme';
import partnersRepository from 'client-sdk/src/Repository/partners-repository';
import handleError from '../../../utils/handleError';
import handleNotfication from '../../../utils/handleNotfication';
import getLogo from 'client-sdk/src/partners/getLogo';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(4),
      border: '1px solid #ddd',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginRight: '10px',
      borderRadius: "7px",
      border: "1px dashed #a7a7a7",
      padding: "0 5px",
      cursor: "pointer"
    },
    textInput: {
      width: '100%',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },
      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
  })
);

function Detail(props: PropsDetail) {
  const classes = useStyles();
  const [openAddUser, setOpenAddUser] = useState(false as boolean);
  const [token, setToken] = useState({} as any);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [logo, setLogo] = useState<string>("")
  const [file, setFile] = useState(null)

  useEffect(() => {
    props.usersByPartnerIdDispatch({
      'partnersId.equals': props.data.id,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    setOpenAddUser(false);
  };

  useEffect(() => {
    getToken(props.data.id);
    getLogoFile()
  }, []);

  const getLogoFile = async () => {
    try {
      // const response = await partnersRepository.getPartnerLogo({ payload: { id: props.data.id } })
      // let base64ImageString = Buffer.from(response.data, 'binary').toString('base64')
      // setLogo(base64ImageString)
      getLogo(props.data.id)
        .then(res => res.blob())
        .then(blob => {
          if (blob.size > 0) {
            setLogo(URL.createObjectURL(blob))
          } else {
            setLogo(null)
          }
        })
    } catch (error) {
      handleError(error)
    }
  }

  const handleChangeFileInput = async (event: any) => {
    const { id, address, name, phoneNumber, ranking, type, workField } = props.data
    const params = {
      id, address, name, phoneNumber, ranking, type, workField
    }
    if (event.target.files[0]) {
      if (event.target.files[0].type !== "image/png") {
        handleNotfication(`فرمت قابل قبول : png`, "error")
        return
      }
      setFile(event.target.files[0]);
      const formData = new FormData();
      formData.append("file", event.target.files[0])
      try {
        const response = await partnersRepository.updatePartnerWithLogo({ payload: { body: formData, params } })
        handleNotfication("لوگوی شما با موفقیت آپلود شد", "success")
        getLogoFile()
        setFile(null)
      } catch (error) {
        handleError(error)
      }
    }
  };

  const removeLogo = async () => {
    try {
      const response = await partnersRepository.removeLogo({ payload: { id: props.data.id } })
      getLogoFile()
      setFile(null)
    } catch (error) {
      handleError(error)
    }
  }

  const getToken = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const { response } = await tokensRepository.getToken({ payload });
      setToken(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const renewToken = async (id: any) => {
    const payload = { id, token: token.token };
    try {
      setLoading(true);
      const { response } = await tokensRepository.renewToken({ payload });
      setToken(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const revokeToken = async (action: any) => {
    const payload = { id: action.id, callback: action.callback };
    try {
      setLoading(true);
      const { response, callback } = await tokensRepository.revokeToken({
        payload,
      });
      callback && callback();
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container spacing={5} alignItems="flex-start">
        <Grid item xs={12}>
          <Paper
            elevation={3}
            className={classes.paper}
            variant="elevation"
            square
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <Icon path={mdiAccountOutline} size={1} />
                  {`نام شرکت:  `}
                  <span>{props.data?.name}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <Icon path={mdiAccountOutline} size={1} />
                  {`(رسمی)نام شرکت:  `}
                  <span>{props.data?.companyName}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <Icon path={mdiTools} size={1} />
                  {`حوزه فعالیت:  `}
                  <span>{props.data?.workField}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <Icon
                    path={mdiPhoneOutline}
                    size={1}
                    style={{ transform: 'scale(-1, 1)' }}
                  />
                  {`شماره تماس:  `}
                  <span>{formaterPhoneNumber(props.data.phoneNumber)}</span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.item}>
                  <Icon path={mdiMapMarkerOutline} size={1} />
                  {`آدرس:  `}
                  <span>{props.data.address}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiAccountTie} size={1} />
                  {`استان:`}
                  <span>{props.data.province}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiAccountTie} size={1} />
                  {`شهر:`}
                  <span>{props.data.city}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiAccountTie} size={1} />
                  {`نماینده شرکت:`}
                  <span>{props.data.representative}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiAccountTieVoice} size={1} />
                  {`سمت نماینده شرکت:`}
                  <span>{props.data.representativePosition}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiArrangeBringToFront} size={1} />
                  {`رتبه‌بندی:`}
                  <span>{props.data.ranking}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiArrangeBringToFront} size={1} />
                  {`کدمالی:`}
                  <span>{props.data.economicCode}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiAccountCash} size={1} />
                  {`بازاریاب:`}
                  <span>{props.data.marketer}</span>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ marginTop: '30px' }}>
              <Grid item xs={12} sm={7} className={classes.item}>
                <span>
                  <Icon
                    path={token?.status === 'ACTIVE' ? mdiCheck : mdiClose}
                    color={
                      token?.status === 'ACTIVE'
                        ? theme.palette.green.main
                        : theme.palette.error.main
                    }
                    size={1}
                    title={token?.status === 'ACTIVE' ? 'فعال' : 'غیر فعال'}
                  />
                </span>
                <span style={{ width: '100%' }}>
                  <TextField
                    label="توکن"
                    className={classes.textInput}
                    value={token.token}
                    id="admin"
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: !!token,
                    }}
                  />
                </span>
              </Grid>
              <Grid
                item
                container
                xs={12}
                sm={5}
                spacing={2}
                style={{ marginTop: 'auto' }}
              >
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    startIcon={<Icon path={mdiPlus} size={1} />}
                    onClick={() => renewToken(props.data.id)}
                  >
                    {`ایجاد توکن جدید`}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    disabled={token?.status !== 'ACTIVE'}
                    startIcon={<Icon path={mdiClose} size={1} />}
                    onClick={() =>
                      revokeToken({
                        id: props.data.id,
                        callback: () => {
                          getToken(props.data.id);
                          setToken({ token: '' });
                        },
                      })
                    }
                  >
                    {`غیر فعال کردن توکن`}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid container item xs={12} direction="row-reverse">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Icon path={mdiPlus} size={1} />}
            onClick={() => setOpenAddUser(true)}
          >{`اضافه کردن کاربر جدید`}</Button>
          <Button
            variant="contained"
            color="default"
            style={{ marginLeft: "10px" }}
            startIcon={<Icon path={mdiMinus} size={1} />}
            onClick={removeLogo}
            disabled={!logo}
          >{`حذف لوگو`}</Button>
          <div className={classes.cancelTitle}>
            <FormLabel style={{ fontSize: '14px', padding: "12px", cursor: "pointer" }} htmlFor="logo">
              {file?.name ? file?.name : "بارگذاری فایل"}
            </FormLabel>
            <IconButton component="label" title="آپلود فایل">
              <Icon
                color={theme.palette.secondary.main}
                path={mdiPaperclip}
                size={1}
              />
              <input
                type="file"
                name="file"
                id='logo'
                onChange={handleChangeFileInput}
                accept="image/png"
                // onClick={(e: React.ChangeEvent<{ value: unknown }>) =>
                //   (e.target.value = null)
                // }
                hidden
              />
            </IconButton>
          </div>
          <div className='w-100'>
            {logo && <img width="100" height="100" src={logo} alt="logo" />}
          </div>
        </Grid>

        <Grid item xs={12}>
          <Paper>
            {
              <>
                <ListUser
                  data={props.usersByPartnerId}
                  partnerId={props.data.id}
                  updatePartnerDispatch={props.updatePartnerAdminDispatch}
                />
              </>
            }
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        fullScreen
        open={openAddUser}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{`اختصاص کاربر به شرکت ${props.data?.name}`}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          <AddUser
            handleClose={handleClose}
            usersList={props.usersBeAdminPartner}
            usersBeAdminPartnerDispatch={props.usersBeAdminPartnerDispatch}
            updatePartnerDispatch={props.updatePartnerAdminDispatch}
            partnerId={props.data.id}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorPropsDetail>({
  usersByPartnerId: makeSelectUsersListByPartnerId(),
  usersBeAdminPartner: makeSelectUsersListBeAdminPartner(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    usersByPartnerIdDispatch: (payload: Object) =>
      dispatch(getUsersByPartnerIdAction(payload)),
    usersBeAdminPartnerDispatch: (payload: Object) =>
      dispatch(getUsersBeAdminPartnerAction(payload)),
    updatePartnerAdminDispatch: (payload: PayloadUpdate) =>
      dispatch(updatePartnerAdminActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Detail);
